/**
 * @typedef {
    | 'listening'
    | 'reading_writing'
    | 'speaking'
 * } SkillId
 */

/**
 * @typedef Skill
 * @property {string} label
 * @property {SkillId} value
 */

/**
 * @type {Skill[]}
 */
const Skills = [
    { label:'Listening', value: 'listening' },
    { label:'Reading/Writing', value: 'reading_writing' },
    { label:'Speaking', value: 'speaking' },
];

export default Skills;